module.exports = __webpack_public_path__ + "img/1.db560aea.png";